import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";
import { speechToken } from "../resources/api";

let cache = { token: null, region: null, exp: 0 };

async function getToken() {
    const now = Date.now();
    if (cache.token && now < cache.exp) return cache;
    const { token, region } = await speechToken();
    cache = { token, region, exp: now + 8 * 60 * 1000 };
    return cache;
}

export async function getSpeechConfig({
    endSilenceMs = "5000",
    initialSilenceMs = "5000",
    phraseTimeoutMs = "100000",
} = {}) {
    const { token, region } = await getToken();
    const config = SpeechSDK.SpeechConfig.fromAuthorizationToken(token, region);
    config.setProperty(SpeechSDK.PropertyId.SpeechServiceConnection_EndSilenceTimeoutMs, endSilenceMs);
    config.setProperty(SpeechSDK.PropertyId.SpeechServiceConnection_InitialSilenceTimeoutMs, initialSilenceMs);
    config.setProperty("SPEECH-PhraseTimeout", phraseTimeoutMs);
    return config;
}
